import React, { useState } from 'react';
import Button from '../common/Button';
import { Modal, ModalContent } from '../common';
import { Heading, Text } from '../common/Typography';

const DeclineGuestMergeModal = ({ isOpen, onClose, onConfirm, guestName, clubName }) => {
  const [loading, setLoading] = useState(false);
  const [userMessage, setUserMessage] = useState('');

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm(userMessage.trim() || null);
    } catch (err) {
      console.error('Error declining merge:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnBackdropClick={!loading}>
      <ModalContent size="small" className="overflow-y-auto">
        <Heading level={3} className="mb-4">
          This Isn&apos;t My Account
        </Heading>

        <div className="space-y-4 mb-6">
          <Text className="text-text-secondary">
            The guest account <strong>{guestName || 'this guest'}</strong> at{' '}
            <strong>{clubName || 'this club'}</strong> doesn&apos;t belong to you.
          </Text>

          <div>
            <Text className="text-sm text-text-secondary mb-2">
              Optional: Help the club admin identify the correct guest account by providing additional
              information:
            </Text>
            <textarea
              value={userMessage}
              onChange={(e) => setUserMessage(e.target.value)}
              placeholder="e.g., 'I've never played at this club before' or 'The name doesn't match mine'..."
              className="w-full px-3 py-2 border border-border-medium rounded-lg focus:outline-none focus:ring-2 focus:ring-primary bg-surface text-text-primary"
              rows={4}
              maxLength={500}
            />
            <Text className="text-xs text-text-muted mt-1">{userMessage.length}/500 characters</Text>
          </div>

          <div className="bg-info-light border border-info/30 rounded-lg p-3">
            <Text className="text-sm text-info-dark">
              The club admin will be notified and can correct the email assignment. You&apos;ll receive a new
              notification once it&apos;s fixed.
            </Text>
          </div>
        </div>

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:gap-3">
          <Button onClick={onClose} variant="outline" className="flex-1" disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} variant="primary" className="flex-1" disabled={loading}>
            {loading ? 'Sending...' : 'Report & Decline'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default DeclineGuestMergeModal;
